import { Link, Button, Box, Stack, Typography } from "fashion/fabrics";
import { EmailIcon, SendIcon } from "fashion/icons";
import CodexUserTargetGrid from "nodes/codex/CodexUserTargetGrid";
import CodexEmbedProductHunt from "nodes/codex/CodexEmbedProductHunt";
import CodexEmbedBetaList from "nodes/codex/CodexEmbedBetaList";

const LINK_MAIL_TO_EMAIL =
  "mailto:concept@memoir.cards?subject=Card%20Memoir%20Concept%20Contact";

const CodexGetStarted = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      The{" "}
      <Box color="secondary.main" component="span" display="inline">
        Card
      </Box>{" "}
      concept
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      Share your promotional idea with us and receive a{" "}
      <Box color="secondary.main" component="span" display="inline">
        free handmade card.
      </Box>
    </Typography>
    <Box margin="auto">
      <Button
        component={Link}
        href={LINK_MAIL_TO_EMAIL}
        size="large"
        variant="outlined"
        color="secondary"
        startIcon={<SendIcon />}
        endIcon={<EmailIcon />}
      >
        Contact us
      </Button>
      <Typography
        mt={0.5}
        color="text.disabled"
        textAlign="center"
        variant="body2"
      >
        We will reply within 1-2 days
      </Typography>
    </Box>
    <CodexUserTargetGrid />
    <Box display="flex" flexWrap="wrap" justifyContent="center" gap={3}>
      <CodexEmbedBetaList />
      <CodexEmbedProductHunt />
    </Box>
  </Stack>
);

export default CodexGetStarted;
